export interface MessengerChatNotification {
    id: string
    messageId: string | null
    unread: boolean
}

export class MessengerNotificationTracker {
    private previous: Map<string, string | null> | null = null

    update(chats: MessengerChatNotification[]): {
        unreadCount: number
        hasNewMessages: boolean
    } {
        const hasNewMessages =
            this.previous !== null &&
            chats.some(
                (chat) =>
                    chat.unread &&
                    chat.messageId !== null &&
                    this.previous?.get(chat.id) !== chat.messageId,
            )

        this.previous = new Map(chats.map((chat) => [chat.id, chat.messageId]))
        return {
            unreadCount: chats.filter((chat) => chat.unread).length,
            hasNewMessages,
        }
    }
}
